import { isSuccess } from '@devexperts/remote-data-ts'
import { Button, cn } from '@spiaggeit/spit-ui'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import { Icon } from '@/assets/icons'
import { useAppSelector } from '@/hooks/store.ts'
import { appSlice } from '@/store/appSlice.ts'
import { cartSlice } from '@/store/cartSlice/index.ts'

import { licenseSlice } from '@/store/licenseSlice'
import { openReservationSummary } from '@/utils/openReservationSummary'

interface Props {
  variant?: 'outline'
}

export const DownloadConfirmationButton = (props: Props) => {
  const isOutlineVariant = props.variant === 'outline'
  const [searchParams] = useSearchParams()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const cartDetail = useAppSelector(cartSlice.selectors.cartDetail)
  const country = useAppSelector(appSlice.selectors.country)
  const { t, i18n } = useTranslation()
  const license = useAppSelector(licenseSlice.selectors.licenseCode)

  const downloadHandler = async () => {
    if (!isSuccess(cartDetail)) {
      throw new Error('Reservation id not found')
    }

    setIsLoading(true)
    openReservationSummary({
      cartDetail: cartDetail.value,
      country,
      lang: i18n.language,
      licenseCode: license,
      searchParams: searchParams,
      target: '_blank',
    })
    setIsLoading(false)
  }

  return (
    <Button
      className={cn('w-full', {
        'btn-outline-secondary--loading': isOutlineVariant,
      })}
      isLoading={isLoading}
      label={t('thankYou.downloadReservationLabel')}
      onClick={downloadHandler}
      variant={props.variant}
    >
      <Icon className="size-5" name="DownloadIcon" />
      {t('thankYou.downloadReservationLabel')}
    </Button>
  )
}
